import apiClient from './api';

/** Website Photos always REPLACE a supplied photo; every call returns the full slot list as one source of truth. */
const path = (restaurantId, locationId) =>
  `/users/restaurant/${restaurantId}/locations/${locationId}/site-photos/`;

export const sitePhotosService = {
  list: async (restaurantId, locationId) => {
    const { data } = await apiClient.get(path(restaurantId, locationId));
    return { slots: data?.data || [], publicSiteSlug: data?.public_site_slug || '' };
  },

  upload: async (restaurantId, locationId, slot, file) => {
    const fd = new FormData();
    fd.append('slot', slot);
    fd.append('image', file);
    const { data } = await apiClient.post(path(restaurantId, locationId), fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data?.data || [];
  },

  remove: async (restaurantId, locationId, slot) => {
    const { data } = await apiClient.delete(`${path(restaurantId, locationId)}${slot}/`);
    return data?.data || [];
  },
};

export default sitePhotosService;
